import { useState, useEffect } from "react";
import ModalUsados from "../../components/Modal";
import ContactFloating from "../../components/contact-floating";
import './Motos.styles.scss';

const Motos = () => {
    const [vehicles, setVehicles] = useState([]);
    const [selectedVehicle, setSelectedVehicle] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [brandFilter, setBrandFilter] = useState('all');
    const [priceFilter, setPriceFilter] = useState('all');
    const [categoryFilter, setCategoryFilter] = useState('all');

    useEffect(() => {
        // Scroll to top when component mounts
        window.scrollTo(0, 0);
        fetchVehicles();
    }, []);

    const fetchVehicles = async () => {
        try {
            setLoading(true);
            const res = await fetch('https://dindorf.vercel.app/api/vehicles', {
                cache: 'no-store',
            });
            if (!res.ok) throw new Error('Error al obtener los vehículos');
            const data = await res.json();
            
            // Filtrar solo motos
            const motos = data.filter(
                ({ tipoVehiculo }) =>
                    Array.isArray(tipoVehiculo) && tipoVehiculo.includes('moto')
            );
            
            setVehicles(motos);
        } catch (error) {
            console.error('Error cargando las motos:', error);
        } finally {
            setLoading(false);
        }
    };

    const openModal = (vehicle) => {
        if (vehicle && Object.keys(vehicle).length > 0) {
            setSelectedVehicle(vehicle);
            setIsModalOpen(true);
        }
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedVehicle(null);
    };

    // Get unique brands for filter
    const uniqueBrands = [...new Set(vehicles.map(vehicle => vehicle.marca))].sort();

    // Categorize motos
    const getMotorcycleCategory = (vehicle) => {
        const cilindrada = parseInt(vehicle.cilindradaMotor) || 0;
        if (cilindrada <= 150) return 'urbana';
        if (cilindrada <= 300) return 'media';
        if (cilindrada <= 600) return 'deportiva';
        return 'alta';
    };

    // Filter vehicles based on search and filters
    const filteredVehicles = vehicles.filter(vehicle => {
        const matchesSearch = 
            vehicle.marca.toLowerCase().includes(searchTerm.toLowerCase()) ||
            vehicle.modelo.toLowerCase().includes(searchTerm.toLowerCase()) ||
            vehicle.variante?.toLowerCase().includes(searchTerm.toLowerCase());
        
        const matchesBrand = brandFilter === 'all' || vehicle.marca === brandFilter;
        
        const matchesCategory = categoryFilter === 'all' || getMotorcycleCategory(vehicle) === categoryFilter;
        
        const matchesPrice = priceFilter === 'all' || (() => {
            const price = vehicle.precioVenta;
            switch(priceFilter) {
                case 'under3': return price < 3000000;
                case '3to6': return price >= 3000000 && price < 6000000;
                case '6to10': return price >= 6000000 && price < 10000000;
                case 'over10': return price >= 10000000;
                default: return true;
            }
        })();

        return matchesSearch && matchesBrand && matchesPrice && matchesCategory;
    });

    return (
        <div className="motos-page">
            <section className="motos-hero section animate__animated animate__fadeIn">
                <div className="container motos-container">
                    <h1 className="section-title">Motocicletas</h1>
                    
                    <div className="page-intro">
                        <p className="intro-text">
                            Descubre nuestra amplia selección de motocicletas. Desde scooters urbanas hasta deportivas de alta cilindrada, 
                            tenemos la moto perfecta para cada estilo de vida. Todas nuestras motos cuentan con el respaldo 
                            de nuestra experiencia de más de 60 años en el sector.
                        </p>
                        <div className="intro-features">
                            <div className="feature-tag">
                                <i className="ri-tools-line"></i>
                                <span>Service Especializado</span>
                            </div>
                            <div className="feature-tag">
                                <i className="ri-shield-check-line"></i>
                                <span>Repuestos Originales</span>
                            </div>
                            <div className="feature-tag">
                                <i className="ri-user-settings-line"></i>
                                <span>Asesoramiento Experto</span>
                            </div>
                        </div>
                    </div>

                    {/* Categorías rápidas */}
                    <div className="categories-section">
                        <h3 className="categories-title">Categorías</h3>
                        <div className="categories-grid">
                            {/* <div className="category-card" onClick={() => setCategoryFilter('urbana')}>
                                <div className="category-icon">
                                    <i className="ri-roadster-line"></i>
                                </div>
                                <h4>Urbanas</h4>
                                <p>Hasta 150cc</p>
                                <span className="category-count">
                                    {vehicles.filter(v => getMotorcycleCategory(v) === 'urbana').length} motos
                                </span>
                            </div>
                            
                            <div className="category-card" onClick={() => setCategoryFilter('media')}>
                                <div className="category-icon">
                                    <i className="ri-motorcycle-line"></i>
                                </div>
                                <h4>Media Cilindrada</h4>
                                <p>150cc - 300cc</p>
                                <span className="category-count">
                                    {vehicles.filter(v => getMotorcycleCategory(v) === 'media').length} motos
                                </span>
                            </div>
                            
                            <div className="category-card" onClick={() => setCategoryFilter('deportiva')}>
                                <div className="category-icon">
                                    <i className="ri-speed-line"></i>
                                </div>
                                <h4>Deportivas</h4>
                                <p>300cc - 600cc</p>
                                <span className="category-count">
                                    {vehicles.filter(v => getMotorcycleCategory(v) === 'deportiva').length} motos
                                </span>
                            </div>
                            
                            <div className="category-card" onClick={() => setCategoryFilter('alta')}>
                                <div className="category-icon">
                                    <i className="ri-flashlight-line"></i>
                                </div>
                                <h4>Alta Cilindrada</h4>
                                <p>+600cc</p>
                                <span className="category-count">
                                    {vehicles.filter(v => getMotorcycleCategory(v) === 'alta').length} motos
                                </span>
                            </div> */}
                        </div>
                    </div>

                    {/* Filtros */}
                    <div className="filters-section">
                        <div className="search-bar">
                            <input
                                type="text"
                                placeholder="Buscar por marca, modelo o versión..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                className="search-input"
                            />
                            <i className="ri-search-line search-icon"></i>
                        </div>

                        <div className="filter-group">
                            <select
                                value={brandFilter}
                                onChange={(e) => setBrandFilter(e.target.value)}
                                className="filter-select"
                            >
                                <option value="all">Todas las marcas</option>
                                {uniqueBrands.map(brand => (
                                    <option key={brand} value={brand}>{brand}</option>
                                ))}
                            </select>

                            <select
                                value={categoryFilter}
                                onChange={(e) => setCategoryFilter(e.target.value)}
                                className="filter-select"
                            >
                                <option value="all">Todas las categorías</option>
                                <option value="urbana">Urbanas (hasta 150cc)</option>
                                <option value="media">Media Cilindrada (150-300cc)</option>
                                <option value="deportiva">Deportivas (300-600cc)</option>
                                <option value="alta">Alta Cilindrada (+600cc)</option>
                            </select>

                            <select
                                value={priceFilter}
                                onChange={(e) => setPriceFilter(e.target.value)}
                                className="filter-select"
                            >
                                <option value="all">Todos los precios</option>
                                <option value="under3">Hasta $3.000.000</option>
                                <option value="3to6">$3.000.000 - $6.000.000</option>
                                <option value="6to10">$6.000.000 - $10.000.000</option>
                                <option value="over10">Más de $10.000.000</option>
                            </select>
                        </div>

                        {categoryFilter !== 'all' && (
                            <button 
                                className="clear-filter"
                                onClick={() => setCategoryFilter('all')}
                            >
                                <i className="ri-close-line"></i>
                                Limpiar filtro de categoría
                            </button>
                        )}
                    </div>

                    {/* Resultados */}
                    <div className="results-info">
                        <span className="results-count">
                            {filteredVehicles.length} motocicleta{filteredVehicles.length !== 1 ? 's' : ''} encontrada{filteredVehicles.length !== 1 ? 's' : ''}
                        </span>
                    </div>

                    {/* Grid de motos */}
                    <div className="vehicles-content">
                        {loading ? (
                            <div className="loading-container">
                                <div className="loading-spinner"></div>
                                <p>Cargando motocicletas...</p>
                            </div>
                        ) : filteredVehicles.length > 0 ? (
                            <div className="motos-grid">
                                {filteredVehicles.map((vehicle) => (
                                    <div key={vehicle._id} className="moto-card">
                                        <div className="moto-image">
                                            <img
                                                src={vehicle.fotos?.[0] || 'https://via.placeholder.com/300'}
                                                alt={`${vehicle.marca} ${vehicle.modelo}`}
                                                loading="lazy"
                                            />
                                            <div className="category-badge">
                                                {getMotorcycleCategory(vehicle) === 'urbana' && 'Urbana'}
                                                {getMotorcycleCategory(vehicle) === 'media' && 'Media'}
                                                {getMotorcycleCategory(vehicle) === 'deportiva' && 'Deportiva'}
                                                {getMotorcycleCategory(vehicle) === 'alta' && 'Alta Gama'}
                                            </div>
                                            {vehicle.año === 0 && vehicle.kilometraje === 0 && (
                                                <div className="new-badge">0 KM</div>
                                            )}
                                        </div>

                                        <div className="moto-info">
                                            <h3 className="moto-title">
                                                {vehicle.marca} {vehicle.modelo}
                                            </h3>
                                            <p className="moto-variant">
                                                {vehicle.variante}
                                            </p>
                                            
                                            <div className="moto-specs">
                                                <div className="spec-item">
                                                    <i className="ri-gas-station-line"></i>
                                                    <span>{vehicle.cilindradaMotor || 'N/A'}cc</span>
                                                </div>
                                                <div className="spec-item">
                                                    <i className="ri-calendar-line"></i>
                                                    <span>{vehicle.año === 0 ? '0 KM' : vehicle.año}</span>
                                                </div>
                                                <div className="spec-item">
                                                    <i className="ri-dashboard-line"></i>
                                                    <span>
                                                        {vehicle.kilometraje === 0 ? '0 km' : 
                                                         vehicle.kilometraje ? vehicle.kilometraje.toLocaleString('es-ES') + ' km' : 'N/A'}
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="moto-price">
                                                $
                                                {vehicle.precioVenta
                                                    ? vehicle.precioVenta.toLocaleString('es-ES')
                                                    : 'Consultar'
                                                }
                                            </div>

                                            <div className="action-buttons">
                                                <button
                                                    className="info-button"
                                                    onClick={() => openModal(vehicle)}
                                                >
                                                    <i className="ri-information-line"></i>
                                                    Ver Detalles
                                                </button>
                                                <button
                                                    className="whatsapp-button"
                                                    onClick={() =>
                                                        window.open(
                                                            `https://wa.me/5492634588256?text=Hola!%20Estoy%20interesado%20en%20la%20moto%20${encodeURIComponent(vehicle.marca)}%20${encodeURIComponent(vehicle.modelo)}`,
                                                            '_blank'
                                                        )
                                                    }
                                                >
                                                    <i className="ri-whatsapp-line"></i>
                                                    Consultar
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="no-results">
                                <i className="ri-motorcycle-line no-results-icon"></i>
                                <h3>No se encontraron motocicletas</h3>
                                <p>Intenta cambiar los filtros o realizar una nueva búsqueda</p>
                            </div>
                        )}
                    </div>

                    {/* Información sobre servicios para motos */}
                    <div className="services-section">
                        <h2 className="services-title">Servicios Especializados para Motos</h2>
                        <div className="services-grid">
                            <div className="service-card">
                                <div className="service-icon">
                                    <i className="ri-tools-fill"></i>
                                </div>
                                <h3>Mantenimiento</h3>
                                <p>Service completo, cambio de aceite y filtros para todas las marcas</p>
                            </div>
                            
                            <div className="service-card">
                                <div className="service-icon">
                                    <i className="ri-settings-4-fill"></i>
                                </div>
                                <h3>Reparaciones</h3>
                                <p>Mecánica general, motor, transmisión y sistemas eléctricos</p>
                            </div>
                            
                            <div className="service-card">
                                <div className="service-icon">
                                    <i className="ri-shopping-cart-fill"></i>
                                </div>
                                <h3>Repuestos</h3>
                                <p>Amplio stock de repuestos originales y alternativos de calidad</p>
                            </div>
                        </div>
                    </div>

                    {/* Call to action */}
                    <div className="cta-section">
                        <h2>¿Buscas una moto específica?</h2>
                        <p>Contáctanos y te ayudamos a encontrar la motocicleta perfecta para ti</p>
                        <button
                            className="cta-button"
                            onClick={() =>
                                window.open(
                                    'https://wa.me/5492634588256?text=Hola,%20estoy%20interesado%20en%20motocicletas.%20¿Podrían%20asesorarme?',
                                    '_blank'
                                )
                            }
                        >
                            <i className="ri-whatsapp-line"></i>
                            Consultar Disponibilidad
                        </button>
                    </div>
                </div>
            </section>

            <ModalUsados
                isOpen={isModalOpen}
                onClose={closeModal}
                selectedItem={selectedVehicle}
            />

            <ContactFloating />
        </div>
    );
};

export default Motos;